import React from "react"
import "./index.scss"
import {observer} from "mobx-react-lite"

const Footer = () => {
  return (
    <footer className="fixed-footer" data-testid="footer-test">
      <span className="copyright">
        GroundTruth, a ZeroToOne.AI company &copy; <span>{new Date().getFullYear()}</span>
        . All rights reserved.{" "}
      </span>
      <ul className="footer-links">
        <li>
          <a
            href="https://www.groundtruth.com/discovery-terms-and-conditions/"
            target="_blank"
            rel="noreferrer"
          >
            Terms
          </a>{" "}
          •&nbsp;
        </li>
        <li>
          <a
            href="https://www.groundtruth.com/privacy-policy/"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
        </li>
      </ul>
    </footer>
  )
}

export default observer(Footer)
